import React, { memo, useCallback, useEffect } from 'react'
import { Route, useHistory, useParams } from 'react-router-dom'
import { useGlobalToast } from 'transfix-ui/components/Toast'
import { TopNav } from 'transfix-ui/components/TopNav'
import { makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { StringParam } from 'use-query-params'
import { LoadDetailsModal } from 'apps/fleet-planner/components/load-details/LoadDetailsModal'
import { CarrierSetupModal } from 'apps/fleet-planner/components/setup-guide'
import { useQueryParams } from 'utils/hooks'
import CarrierAppHomepageBody from './components/CarrierAppHomepageBody'

const useCarrierAppHomepageStyles = makeStyles(theme => ({
  topNav: {
    background: `linear-gradient(90deg, ${brandColors.coolGray8} 61.85%, ${brandColors.coolGray6} 100%)`,
    border: '0px',
    color: brandColors.white,
    display: 'flex',
    padding: `${theme.spacing(3)} ${theme.spacing(2.5)}`,
    position: 'fixed',
    width: '100%',
    zIndex: 20,
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },

    '& .top-nav-menu': {
      margin: `0 ${theme.spacing(4)} 0 0`,
      width: 'auto',

      '& button': {
        background: 'transparent',
        borderColor: 'transparent',
        minWidth: 'auto',
        border: '0px',
        padding: '0px',
      },

      '& svg': {
        color: brandColors.white,
      },
    },

    '& .top-nav-content': {
      padding: 0,
      height: `${theme.spacing(3)} !important`,
      '& > div': {
        padding: 0,
      },
    },
  },
}))

export interface ICarrierAppHomepageProps {}

const CarrierAppHomepage = memo<ICarrierAppHomepageProps>(() => {
  const classes = useCarrierAppHomepageStyles()
  const history = useHistory()

  const { shipmentId } = useParams<{
    shipmentId: string
  }>()

  const [{ safetyLetter }] = useQueryParams({ safetyLetter: StringParam })

  const { openToast } = useGlobalToast()

  useEffect(() => {
    if (safetyLetter) {
      openToast({
        toastMessage: 'Safety summary successfully submitted.',
        toastType: 'default',
      })
    }
    // openToast is unstable and triggers infinite rerenders
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [safetyLetter])

  const closeModalHandler = useCallback(() => {
    history.replace(`/home${history.location.search}`)
  }, [history])

  return (
    <div>
      <TopNav
        title='Home'
        showMenuIcon={false}
        className={classes.topNav}
        includeTopNavDefaultClass={false}
      />
      <CarrierAppHomepageBody />
      <Route exact path='/home/:shipmentId/details/:action?'>
        <LoadDetailsModal
          id={shipmentId}
          onClose={closeModalHandler}
          path='/home/:shipmentId/details'
        />
      </Route>
      <Route exact path='/home/carrier-setup'>
        <CarrierSetupModal onClose={closeModalHandler} />
      </Route>
    </div>
  )
})

export default CarrierAppHomepage
